<template>
  <div class="page-opportunities-form" v-loading.fullscreen="loading" id="top">
    <div class="container is-gap-top section-top"
      data-aos="fade-in"
      data-aos-once="true"
      id="top-main"
      v-if="isSubmitted">
      <h1 style="text-align: left;">Reference Form</h1>
      <hr />
      <div class="info-rows is-gap-top" style="min-height:250px;display:flex;align-items:center;background-color:#ededed;border-radius:3px;padding:30px;">
        <div>
          (Reference form had been submitted successfully.)
        </div>
      </div>
    </div>

    <div class="container is-gap-top section-top"
      data-aos="fade-in"
      data-aos-once="true"
      id="top-main"
      v-if="!isSubmitted">
      <h1 style="text-align: left;">Reference Form</h1>
      <hr />
      <div class="info-rows" v-for="(infoRow, ir) in infoRows" :key="`${ir}`">
        <div class="info-key">{{ infoRow.label }}</div>
        <div class="info-value">{{ getInfo(infoRow.id) }}</div>
      </div>
      <div class="info-rows is-gap-top">
        Please fill out the following form for the candidate. We appreciate your honesty and time.
      </div>
    </div>

    <div class="container is-gap-top color-lightgreen-bg" data-aos="fade-in" data-aos-once="true" id="top-main"
      v-if="!isSubmitted">
      <div class="columns is-gapless is-flex is-multiline">
        <div class="column is-12 has-text-left">

          <el-button class="inline-middle is-gap-large-top"
            v-if="isDevOrLocal"
            type="info" @click="onFill" style="margin-left:15px;" size="mini">
            Auto Fill (Debug)
          </el-button>

          <div class="section-form">
            <formm
              ref="form"
              :form="form"
              :rules="formRules"
              :columns="formColumns"
              :data="formData">
            </formm>
          </div>

        </div>
      </div>
    </div>

    <div class="container is-gap-large-top is-gap-large-bottom" data-aos="fade-in" data-aos-once="true"
      v-if="!isSubmitted">
      <div class="columns is-gapless is-flex is-multiline">
        <div class="column is-12 has-text-left">
          <div class="section-form" style="margin-top:0;">
            <el-button class="button color-green-bg"
              @click="onSubmit">
              Submit
            </el-button>

            <div v-if="isValidateError"
              class="column is-full label"
              style="color:#F56C6C;font-size:12px;">
              * Form contains error, please kindly recheck.
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import Constants from '@/constants'
import ReferenceFormConstants from '@/pages/opportunities/formreference/formconstants'
import Util from '@/util'
import ObjectUtil from '@/util/object'
// import StringUtil from '@/util/string'
// import FileUtil from '@/util/file'
import EventBus from '@/controllers/EventBus'
// import Site from '@/apis/site'
import SiteAims from '@/apis/aims'

// import InfoBlock from '@/pages/base/infoblock'
import Formm from '@/base/form'

// import File from '@/apis/file'
// import Upload from '@/apis/upload'

export default {
  name: 'page-opportunities-form',
  props: {
    // msg: String
  },
  components: {
    // InfoBlock,
    Formm,
  },
  data () {
    return {
      name: 'form-opening',
      loading: false,
      isDesktop: true,
      isDevOrLocal: (Constants.isDev || Constants.isLocalhost),
      referenceToken: this.$route.params.referenceToken,
      // blocks
      blocks: [],
      infoRows: [{
        id: 'applicant.name',
        label: 'Applicant Name',
      }],
      // form
      form: {},
      formKeys: [],
      formRules: ReferenceFormConstants.Form.getValidators(this, {
        isRelocate: false,
        isProvidedService: false
      }),
      formColumns: ReferenceFormConstants.Form.COLUMNS,
      formData: {
        dataSelectYesNo: Constants.OPTIONS_YES_NO,
        optionsState: [],
        dataReferenceQuestions: [],
        dataReference: {},
      },
      isSubmitted: false,
      // validator
      isValidateError: false,
      validateErrorSection: undefined,
    }
  },
  computed: {
    Util: function () {
      return Util
    },
  },
  watch: {
  },
  created () {
  },
  async mounted () {
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    this.clear()
    this.setRules()

    this.load()
    await this.refresh()
  },
  methods: {
    clear () {
      let keyinfos = ReferenceFormConstants.Form.KEYS
      let form = Util.request.getDefaults(keyinfos)
      this.$set(this, 'form', form)
    },

    load () {
      // this.$set(this.form, '')
      if (this.$route.query.field) {
        this.$set(this.form, 'field', this.$route.query.field)
      }
    },

    setRules () {
      let params = {
        isRelocate: this.isRelocate,
        isProvidedService: this.isProvidedService,
      }
      let rules = ReferenceFormConstants.Form.getValidators(this, params)
      this.$set(this, 'formRules', rules)

      this.$nextTick(() => {
        if (this.$refs.form && this.$refs.form.clearValidate) {
          this.$refs.form.clearValidate()
        }
      })
    },

    getInfo (key) {
      let value = ObjectUtil.get(this.formData.dataReference, key)
      return value == null ? '' : value
    },

    async refresh () {
      try {
        this.$set(this, 'loading', true)
        // data
        let promises = []
        let promise
        promise = this.getReferenceData()
        promises.push(promise)
        promise = this.getReferenceQuestions()
        promises.push(promise)
        await Promise.all(promises)
        this.$set(this, 'loading', false)
      } catch (error) {
        this.$set(this, 'loading', false)
        this.$message({
          message: `Refresh failed: ${error.message || error}`,
          type: 'error'
        })
      }
    },

    async getReferenceData () {
      let response = await SiteAims.getReference(this.referenceToken)
      let data = (response && response.data) || {}
      // to test:
      // 3765-4545-6067-3390
      // 9218-6147-5333-6857
      this.$set(this.formData, 'dataReference', data)
      // this.$set(this, 'isSubmitted', (data != null && data.questions != null && data.questions.length > 0))
      this.$set(this, 'isSubmitted', (data != null && data.isFormCompleted))
    },

    async getReferenceQuestions () {
      let response = await SiteAims.getNominalData('reference_questions')
      let data = (response && response.data) || []
      // data = _.map(data, (item) => {
      //   return {
      //     id: item.id,
      //     label: item.name,
      //   }
      // })
      // this.$set(this.formData, 'dataReferenceQuestions', data)

      let columns = _.map(data, (item, index) => {
        let isRadio = item.inputType === 'radio'
        let inputOptions
        try {
          inputOptions = JSON.parse(item.inputOptions)
        } catch (error) {
          console.error(`invalid input options for ${index}: ${item.inputOptions}`)
          // let inputOptions = `[{ "value": 1, "label": "Yes" }, { "value": 2, "label": "No" }, { "value": 0, "label": "N/A" }]`
          inputOptions = [{ value: 1, label: 'Yes' }, { value: 2, label: 'No' }, { value: 0, label: 'N/A' }]
        }
        let options = isRadio ? {
          data: _.map(inputOptions, (op) => {
            return {
              id: op.value,
              value: op.value,
              label: op.label,
            }
          })
        } : {}
        return {
          // ...item,
          name: `${item.id}`,
          label: `${index + 1}. ${item.name}`,
          type: item.inputType,
          class: 'is-12',
          ...options,
        }
      })
      // console.log('-- columns', columns)
      this.$set(this, 'formColumns', columns)

      let rules = _.map(data, (item) => {
        let trigger = 'blur'
        if (item.inputType === 'radio') trigger = 'change'
        return {
          [item.id]: [{ required: true, trigger, message: 'Required' }],
        }
      })
      rules = _.assign({}, ...rules)
      this.$set(this, 'formRules', rules)

      let keyinfos = _.map(data, (item) => {
        return { key: `${item.id}`, type: (item.inputType === 'radio' ? 'int' : 'string'), default: undefined }
      })
      this.$set(this, 'formKeys', keyinfos)
    },

    onFill () {
      let keyinfos = this.formKeys
      let form = {}
      for (let k in keyinfos) {
        let keyinfo = keyinfos[k]
        let key = keyinfo.key
        let type = keyinfo.type
        switch (type) {
          case 'int':
            form[key] = 1
            break
          default:
            form[key] = `test 123${parseInt(k, 10) + 1}`
            break
        }
      }
      this.$set(this, 'form', form)
    },

    // validate / submit

    async validate () {
      let isValidateError = false
      this.validateErrorSection = undefined
      try {
        if (this.$refs.form && this.$refs.form.validate) {
          await this.$refs.form.validate()
        }
      } catch (error) {
        if (error !== false) throw error
        isValidateError = true
        if (!this.validateErrorSection) {
          this.validateErrorSection = 'main'
        }
      }

      if (isValidateError) {
        let returnFalse = false
        throw returnFalse
      }
    },

    async onSubmit () {
      try {
        this.loading = true
        if (this.referenceToken == null || `${this.referenceToken}`.length <= 0) {
          throw new Error('invalid reference token')
        }

        await this.validate()
        let response

        // keyinfos
        // let keyinfos = ReferenceFormConstants.Form.KEYS
        let form = Util.request.parseForm(this.formKeys, this.form)
        console.log(`${this.name}: form.submit.form`, form)

        let questions = _.map(form, (value, key) => {
          return {
            question_number: parseInt(key, 10),
            answer: value,
          }
        })
        console.log(`${this.name}: form.submit`, { questions })
        // response = { status: 'ok' }
        response = await SiteAims.createReference(this.referenceToken, { questions })
        // if (!response || !response.data || !response.data.id) {
        //   throw new Error('invalid reference ID')
        // }
        console.log(`${this.name}: form.submit.response`, response)
        // let applicantId = response.data.id

        this.$alert('Thank you for your response. Your reference form has successfully been submitted.', {
          type: 'success'
        })

        // this.$router.push({ name: 'landing' })

        await this.refresh()

        this.loading = false
      } catch (error) {
        this.loading = false
        this.isValidateError = (error === false)
        if (error === false) {
          let validateErrorSection = this.validateErrorSection
          let anchor = `#top${validateErrorSection ? `-${validateErrorSection}` : ''}`
          this.$scrollTo(anchor)
          return
        }
        this.$message({
          message: `Submit failed: ${error.message || error}`,
          type: 'error'
        })
      }
    }
  }
}
</script>

<style lang="scss" src="../../../styles/base.scss"></style>
<style scoped lang="scss">
@import "../../../styles/app_setting.scss";

.page-opportunities-form {
  .section-form {
    margin: 36px 24px;
    @media screen and (max-width: $mobile) {
      margin: 24px 18px;
    }
  }

  .info-rows {
    display: flex;
    flex-direction: row;
    .info-key {
      flex: 1;
      // background-color: $color-primary;
      text-align: left;
      margin-top: 8px;
    }
    .info-value {
      flex: 4;
      text-align: left;
      margin-top: 8px;
    }
  }
}

</style>
